<template>
  <RevLink
    class="flex h-full flex-nowrap items-center gap-12"
    :style="{ color }"
    :to="url"
    :tracking
    :underlined="false"
    @click="$emit('click-item')"
  >
    <component
      :is="resolveNavIcon(icon)"
      v-if="icon"
      :data-test="`icon-${icon.toLowerCase()}`"
    />
    <span>{{ title }}</span>
  </RevLink>
</template>

<script setup lang="ts">
import { RevLink } from '@ds/components/Link'
import type { Location } from '@ds/types/Location'

import { resolveNavIcon } from '../../utils/navigationIcons'

defineProps<{
  title: string
  color?: string
  icon?: string
  url: Location
  tracking?: Record<string, string>
}>()

defineEmits<{
  'click-item': []
}>()
</script>
